import { baseChartOptions } from './echarts-config';

type BarDatum = {
  label: string;
  count: number;
  color?: string;
};

/**
 * Horizontal bar options shared by every "ranked breakdown" chart in Engagement Metrics
 * (type/billable, message type, category, specialty) — same grid/axis/bar recipe, only the
 * label/value extraction and per-item color differ per caller.
 */
export const buildHorizontalBarOptions = (data: BarDatum[], gridLeft: number, barColor?: string) => ({
  ...baseChartOptions,
  grid: { ...baseChartOptions.grid, left: gridLeft, right: 20 },
  xAxis: {
    type: 'value' as const,
    axisLabel: { fontSize: 11, color: '#7f8a83' },
    splitLine: { lineStyle: { color: '#edeae3' } },
  },
  yAxis: {
    type: 'category' as const,
    inverse: true,
    data: data.map((item) => item.label),
    axisLabel: { fontSize: 11, color: '#46584f' },
    axisLine: { show: false },
    axisTick: { show: false },
  },
  series: [
    {
      type: 'bar' as const,
      data: data.map((item) => ({
        value: item.count,
        itemStyle: { color: item.color ?? barColor, borderRadius: [0, 4, 4, 0] },
      })),
      label: { show: true, position: 'right' as const, color: '#1b2a23', fontWeight: 700 },
      barMaxWidth: 24,
    },
  ],
});

type DonutSlice = {
  name: string;
  value: number;
  color: string;
};

/** Donut options shared by the billable-split and referral-source charts. */
export const buildDonutOptions = (slices: DonutSlice[]) => ({
  tooltip: { trigger: 'item' as const, formatter: '{b}: {c} ({d}%)' },
  legend: { bottom: 0, textStyle: { fontSize: 11, color: '#46584f' } },
  series: [
    {
      type: 'pie' as const,
      radius: ['52%', '74%'],
      center: ['50%', '44%'],
      avoidLabelOverlap: true,
      label: { formatter: '{b}\n{c} ({d}%)', color: '#46584f', fontSize: 11 },
      data: slices.map((slice) => ({
        name: slice.name,
        value: slice.value,
        itemStyle: { color: slice.color },
      })),
    },
  ],
});
